export default "__VITE_ASSET__CbuiuItr__"